import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { MainContext } from "../../../MainContext";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Flag from "react-world-flags";
import { request } from "../../../request";

const options = [
    { name: "Wallet", location: "/wallet", key: "account" },
    { name: "Transactions", location: "/transactions", key: "transaction" },
    { name: "Customers", location: "/customers", key: "customer" },
    { name: "History", location: "/history", key: "history" },
    // { name: "Automation", location: "/automation", key: "automation", hidden: true },
    { name: "Users", location: "/users", key: "user" },
];
const MobileNavBar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { darkMode, formatNumber, token, capital, premissions, language, switchLanguage, texts } = useContext(MainContext);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [pages, setPages] = useState([]);
    const [capitalCpllapsed, setCapitalCollapsed] = useState(true);
    const [hidePass, setHidePass] = useState(false);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElForMenu, setAnchorElForMenu] = useState(null);
    const openMenu = Boolean(anchorElForMenu);
    const handleClickMenu = (event) => {
        setAnchorElForMenu(event.currentTarget);
    };
    const handleCloseForMenu = () => {
        setAnchorElForMenu(null);
    };
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleNavigate = (page_location) => {
        if (location.pathname !== page_location) {
            navigate(page_location);
        }
        setAnchorElForMenu(null);
    };

    const logOut = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to log out?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem("token");
                localStorage.removeItem("premissions");
                navigate("/login");
            }
        });
    };

    const reloadPage = () => {
        window.location.reload();
    };

    useEffect(() => {
        const newPages = [];
        Object.entries(premissions).map(([key, value]) => {
            if (value.default) {
                newPages.push(options.find((p) => p.key === key));
            }
        });
        setPages(newPages);
    }, [premissions]);

    const isLoginPage = location.pathname === "/login";

    return (
        <header style={{ backgroundColor: darkMode ? "black" : "white" }} className="mobile-navbar fixed lg:flex sm:relative items-center justify-between whitespace-nowrap border-b border-solid border-b-[#f0f2f4] px-10 py-3">
            <div className="mobile-navbar-items flex items-center gap-4 text-[#111418]">
                <div className="size-2 w-12 h-12" onClick={() => reloadPage()}>
                    <img src="/img/logo.png" alt="CryptoTracker Logo" className="w-full h-full" />
                </div>
                {!isLoginPage && premissions?.account?.capital && (
                    <div className="capital-container">
                        <div onClick={() => setCapitalCollapsed(!capitalCpllapsed)} className="main">
                            {hidePass ? (
                                <>
                                    <p>{capital.capital} Դ</p>
                                    {capitalCpllapsed ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                                    <VisibilityOffIcon onClick={() => setHidePass((prev) => !prev)} />
                                </>
                            ) : (
                                <>
                                    <p>************</p>
                                    {<KeyboardArrowDownIcon disablePointerEvents />}
                                    <VisibilityIcon onClick={(prev) => setHidePass((prev) => !prev)} />
                                </>
                            )}
                        </div>
                        <>
                            {hidePass ? (
                                <div style={{ opacity: capitalCpllapsed ? "" : "1" }} className="rest">
                                    {capital.allAmount.map((curr) => {
                                        return (
                                            <div>
                                                <p>
                                                    {curr.currency_name}: {curr.value} ({curr.avg.toFixed(2)})
                                                </p>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                ""
                            )}
                        </>
                    </div>
                )}
                {!isLoginPage && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="language-toggle">
                            <button onClick={() => switchLanguage(language === "en" ? "ru" : "en")} className={`toggle-button ${language === "en" ? "english" : "russian"}`}>
                                {language === "en" ? (
                                    <>
                                        <Flag code="US" style={{ width: "24px", height: "16px" }} />
                                    </>
                                ) : (
                                    <>
                                        <Flag code="RU" style={{ width: "24px", height: "16px" }} />
                                    </>
                                )}
                            </button>
                        </div>
                        <div className="lg:flex sm:relative items-center gap-8">
                            <div className="relative">
                                {/* Dropdown menu for mobile, horizontal links for larger screens */}
                                <div>
                                    <IconButton aria-label="more" id="long-button" aria-haspopup="true" onClick={handleClickMenu} sx={{ color: "white" }}>
                                        <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                        id="long-menu"
                                        MenuListProps={{
                                            "aria-labelledby": "long-button",
                                        }}
                                        anchorEl={anchorElForMenu}
                                        open={openMenu}
                                        onClose={handleCloseForMenu}
                                        slotProps={{
                                            paper: {
                                                style: {
                                                    maxHeight: 58 * 4.5,
                                                    width: "20ch",
                                                },
                                            },
                                        }}
                                    >
                                        {pages.map(
                                            (option) =>
                                                option && (
                                                    <MenuItem key={option.location} selected={option.key === "Pyxis"} onClick={() => handleNavigate(option.location)}>
                                                        {option.name}
                                                    </MenuItem>
                                                )
                                        )}
                                        <MenuItem
                                            key="logout"
                                            onClick={() => {
                                                handleCloseForMenu(); // Close the dropdown menu
                                                logOut(); // Call the logOut function
                                            }}
                                        >
                                            Log Out
                                        </MenuItem>
                                        <MenuItem
                                            key="changePassword"
                                            onClick={async () => {
                                                handleCloseForMenu(); // Close the dropdown menu
                                                const { value: formValues } = await Swal.fire({
                                                    title: "Enter new password",
                                                    html: `
														<input type="text" id="swal-input2" class="swal2-input" placeholder="New password">
													  `,
                                                    focusConfirm: false,
                                                    showCancelButton: true,
                                                    preConfirm: () => {
                                                        const password = document.getElementById("swal-input2").value;

                                                        if (!password) {
                                                            Swal.showValidationMessage("Please fill both inputs");
                                                            return null;
                                                        }

                                                        return { password };
                                                    },
                                                });

                                                if (!formValues) return;

                                                try {
                                                    request.post("/user/change-password/", formValues);

                                                    Swal.fire("Success!", "Your password has been changed.", "success");
                                                } catch (err) {
                                                    Swal.fire("Error!", "Something went wrong. You provided wrong data.", "error");
                                                }
                                            }}
                                        >
                                            Change Password
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

export default MobileNavBar;
